(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/high-five-next-race/views/countdown.js') >= 0) return;  svs.modules.push('/components/racing/high-five-next-race/views/countdown.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.racing=_svs.racing||{};
_svs.racing.high_five_next_race=_svs.racing.high_five_next_race||{};
_svs.racing.high_five_next_race.templates=_svs.racing.high_five_next_race.templates||{};
svs.racing.high_five_next_race.templates.countdown = Handlebars.template({"0":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"next-race-timer\">\n    <div class=\"time-left\">\n      "
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"countdown") : stack1)) != null ? lookupProperty(stack1,"hours") : stack1), depth0))
    + ":"
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"countdown") : stack1)) != null ? lookupProperty(stack1,"minutes") : stack1), depth0))
    + ":"
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"countdown") : stack1)) != null ? lookupProperty(stack1,"seconds") : stack1), depth0))
    + "\n    </div>\n  </div>\n";
},"1":function(container,depth0,helpers,partials,data) {
    return "  <div class=\"next-race-no-timer-text\">\n    Loppet startar snart\n  </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"showCountdown") : stack1),{"name":"if","hash":{},"fn":container.program(0, data, 0),"inverse":container.program(1, data, 0),"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":11,"column":7}}})) != null ? stack1 : "");
},"useData":true});
Handlebars.partials['components-racing-high_five_next_race-countdown'] = svs.racing.high_five_next_race.templates.countdown;
})(svs, Handlebars);


 })(window);